function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import Base from './base';
import Color, { colorToRGBA } from '../color.js';
import _ from 'underscore';
import URI from 'urijs';
import { hasRootKey, popRootKey } from '../util';
export var CHART_TYPES = ['bar', 'colum', 'donut', 'standard', 'cluster', 'spotlight', 'wordcloud'];
export var SCALE_MAP = [{
  newKey: 'keyword_scale',
  oldKey: 'chartKeywordScale',
  scale: [0.3, 2.5]
}, {
  newKey: 'label_scale',
  oldKey: 'chartLabelScale',
  scale: [0.3, 2.5]
}, {
  newKey: 'voting_instructions_scale',
  oldKey: 'headerInstructionScale',
  scale: [1, 1.45]
}, {
  newKey: 'title_scale',
  oldKey: 'headerScale',
  scale: [0.4, 3]
}, {
  newKey: 'message_scale',
  oldKey: 'messageScale',
  scale: [0.4, 3]
}];

function rmCamelCaseAttrs(attrs) {
  attrs = attrs || {};
  attrs = JSON.parse(JSON.stringify(attrs, function (k, v) {
    return v === undefined ? null : v;
  }));

  var BLACKLIST_ATTRS = _toConsumableArray(SCALE_MAP.map(function (scale) {
    return scale.oldKey;
  }));

  _.intersection(BLACKLIST_ATTRS, Object.keys(attrs)).forEach(function (attr) {
    delete attrs[attr];
  });

  return attrs;
}

var FlashOptions = /*#__PURE__*/function (_Base) {
  _inheritsLoose(FlashOptions, _Base);

  function FlashOptions() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = FlashOptions.prototype;

  _proto.url = function url() {
    return URI('/polls').segment(this.poll.permalink()).segment('flash_options.json').toString();
  };

  _proto.isNew = function isNew() {
    return false;
  };

  _proto.isSegmented = function isSegmented() {
    if (this.poll) {
      var isComparisonReportingEnabled = this.poll.get('comparison_reporting');
      var isMultipleChoicePollType = this.poll.type() === 'multiple_choice_poll';

      if (isComparisonReportingEnabled && isMultipleChoicePollType) {
        return this.has('teamPollPermalink') && !!this.get('teamPollPermalink');
      } else {
        return false;
      }
    } else {
      return this.has('teamPollPermalink') && !!this.get('teamPollPermalink');
    }
  };

  _proto.toJSON = function toJSON(options) {
    if (options === void 0) {
      options = {};
    }

    _.defaults(options, {
      root: true
    });

    var json = rmCamelCaseAttrs(_Base.prototype.toJSON.apply(this, arguments));

    if (options.root) {
      return {
        flash_options: json
      };
    } else {
      return json;
    }
  };

  _proto.setChartType = function setChartType(newType) {
    newType = newType.toLowerCase();

    if (CHART_TYPES.includes(newType)) {
      this.set('chart_type', newType);
    }
  };

  _proto.enableSegmentation = function enableSegmentation(permalink) {
    if (!permalink) return;

    if (this.poll) {
      if (this.poll.get('comparison_reporting')) {
        this.set({
          teamPollPermalink: permalink
        });
      }
    } else {
      this.set({
        teamPollPermalink: permalink
      });
    }
  };

  _proto.disableSegmentation = function disableSegmentation() {
    if (!this.get('teamPollPermalink')) return;
    this.set({
      teamPollPermalink: null
    });
  };

  _proto.getColorRGBA = function getColorRGBA(property, alpha) {
    if (alpha === void 0) {
      alpha = 1;
    }

    return colorToRGBA(this.get(property), alpha);
  };

  _proto.getColorHex = function getColorHex(property) {
    return Color.intToHex(this.get(property));
  };

  _proto.getColorARGB = function getColorARGB(property, alpha) {
    if (alpha === void 0) {
      alpha = 1;
    }

    var hex = Color.intToHex(this.get(property));

    if (hex) {
      alpha = Math.floor(alpha * 255).toString(16);
      return "#" + alpha + hex.slice(1);
    } else {
      return undefined;
    }
  };

  _proto.set = function set(key, value, options) {
    if (!key) return this;
    var attrs = {};

    if (_typeof(key) === 'object') {
      attrs = key;
      options = options || value;
    } else {
      (attrs = {})[key] = value;
    } // TODO: Remove this hack when backend stops requiring root keys for any
    // POST requests.


    if (attrs.flash_options) {
      if (hasRootKey(attrs)) {
        attrs = popRootKey(attrs);
      } else {
        var nestedAttrs = delete attrs.flash_options;
        attrs = Object.assign({}, attrs, nestedAttrs);
      }
    }

    options || (options = {});
    attrs = rmCamelCaseAttrs(attrs);
    return _Base.prototype.set.call(this, attrs, options);
  } // Fetching flash_options doesn't return obj with root key
  ;

  _proto.parse = function parse(attrs) {
    // Patch up some  flash_options *values* that might be invalid from a Rails
    // model that allows nil for Flash, but shouldn't allow nil for viz. Proper
    // key structure for new/copy is still handled in
    // Poll.rb#merge_flash_options stuff
    if (attrs) {
      if (!_.isUndefined(attrs.headerLogoPlacement)) {
        if (!attrs.headerLogoPlacement) {
          attrs.headerLogoPlacement = 'center';
        }
      }

      attrs = rmCamelCaseAttrs(attrs);
    }

    return attrs;
  };

  _proto.processLiveResponse = function processLiveResponse(data) {
    var _this = this;

    if (data === void 0) {
      data = {};
    }

    if (!this.throttledUpdate) {
      this.throttledUpdate = _.throttle(function (flashOptions) {
        if (_this.isSaving) {
          return;
        }

        _this.set(flashOptions);
      }, 1000);
    }

    if (data.flash_options && this.poll && !this.poll.displayPanel) {
      this.throttledUpdate(data.flash_options);
    }
  };

  _createClass(FlashOptions, [{
    key: "defaults",
    get: function get() {
      return {
        segmentationSizedByPercentage: true
      };
    }
  }]);

  return FlashOptions;
}(Base);

export { FlashOptions as default };